import { atom } from "jotai";
import type { UtmRequestParams } from "types/api";

/** UTM パラメータ記録用の atom */
export const utmRequestParamsAtom = atom<UtmRequestParams>({});
